<template>
<div class="chapter">
<div class="inner_page">
<h2 title="Title"></h2>
<p class="center"><img alt="" src="Images/6974_BISFULLLOGO.jpg"/></p>
<p class="first"> </p>
<p class="h2" id="heading_id_2">Matthew<br/>
  The Gospel of Identity</p>
<p class="center"><img alt="" src="Images/TPimage.jpg"/></p>
<p class="h3" id="heading_id_3">Michael Card</p>
<p class="first"> </p>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/books" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?6358d0f8